<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <h6>Dados gravados em {{ agendamento.created_at_f }}</h6>
          <h6 v-show="agendamento.updated_at">Última edição em {{ agendamento.updated_at_f }}</h6>
        </div>
        <div class="col-md-12">
          <label>Unidade</label>
          <input type="text" class="form-control" v-model="agendamento.unidade.nome" disabled />
        </div>
        <div class="col-md-6">
          <label>Setor</label>
          <input type="text" class="form-control" v-model="agendamento.setor.nome" disabled />
        </div>
        <div class="col-md-6">
          <label>Data agendada</label>
          <input type="text" class="form-control" v-model="agendamento.data_agendado_f" disabled />
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="agendamento.nome" disabled />
        </div>
        <div class="col-md-12">
          <label>Descrição</label>
          <textarea type="text" class="form-control" v-model="agendamento.descricao" disabled></textarea>
        </div>
        <div class="col-md-4">
          <label>CPF</label>
          <input type="text" class="form-control" v-model="agendamento.cpf" disabled />
        </div>
        <div class="col-md-4">
          <label>CNS</label>
          <input type="text" class="form-control" v-model="agendamento.cns" disabled />
        </div>
        <div class="col-md-4">
          <label>Status</label>
          <input type="text" class="form-control" v-model="agendamento.status_f" disabled />
        </div>
        <div class="col-md-4">
          <label>ID Externo (API)</label>
          <input type="text" class="form-control" v-model="agendamento.id_externo" disabled />
        </div>
        <div class="col-md-4">
          <label>CNS Profissional</label>
          <input type="text" class="form-control" v-model="agendamento.id_externo" disabled />
        </div>
        <div class="col-md-4">
          <label>Chave de confirmação</label>
          <input type="text" class="form-control" v-model="agendamento.chave_confirmacao" disabled />
        </div>
        <div class="col-md-12">
          <label>JSON</label>
          <textarea type="text" class="form-control" v-model="agendamento.json" disabled></textarea>
        </div>
        <div class="col-md-6">
          <label>ID central</label>
          <input type="text" class="form-control" v-model="agendamento.id" disabled />
        </div>
        <div class="col-md-6">
          <label>ID original</label>
          <input type="text" class="form-control" v-model="agendamento.original_id" disabled />
        </div>
        <div class="col-md-6 text-left d-flex align-items-end">
          <h5>Última sincronização realizada em {{ agendamento.sincronizacao_f }}</h5>
        </div>
        <div class="col-md-6 text-right">
          <hr />
          <router-link to="/agendamentos" class="btn btn-back">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      agendamento: {},
    };
  },
  computed: {},
  methods: {
    getAgendamento: function (id) {
      const self = this;
      const api = self.$store.state.api + "agendamentos/" + id + '?with[]=unidade&with[]=setor';

      axios
        .get(api)
        .then((response) => {
          if(response.data.data[0])
          {
            self.agendamento = response.data.data[0];            
            self.setLoader(50);
          }else{
            this.$router.push("/no-item");
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getAgendamento(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>